import posthogClient, { PostHogConfig } from 'posthog-js';

function getPosthogOptions(): Partial<PostHogConfig> {
	if ((import.meta.env.VITE_ENV ?? '').toLowerCase() === 'local') {
		console.log({
			env: (import.meta.env.VITE_ENV ?? '').toLowerCase(),
		});
		return { api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? '' };
	}

	return {
		// can't get import.meta.env.BASE_URL to work correctly

		api_host: [window.location.origin, 'ph_analytics'].join('/'),
		ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	};
}

posthogClient.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY ?? '', getPosthogOptions());

export default posthogClient;
